import React from "react";
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { colors } from "../../theme/theme";
import { useLocation, useNavigate } from "react-router-dom";

const SidebarMenuItem = ({ open, sidebarData }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <List sx={{ flex: 1, m: 2 }} disablePadding>
      {sidebarData.map((item, index) => {
        const isSelected =
          location.pathname === item.route ||
          location.pathname.startsWith(item.route + "/");
        const IconComponent = isSelected ? item.FocusedIcon : item.Icon;

        return (
          <Tooltip
            title={!open ? item.title : ""}
            placement="right"
            key={item.id}
          >
            <ListItem disablePadding>
              <ListItemButton
                disableGutters
                onClick={() => {
                  navigate(item.route);
                }}
                sx={{
                  px: 1.5,
                  borderRadius: 2,
                  background: isSelected ? colors.gradientBtn : "none",
                  "&:hover": {
                    backgroundColor: colors.primary + "33",
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    color: isSelected ? "#fff" : colors.primary,
                    minWidth: "auto",
                    mr: open ? 2 : 0,
                  }}
                >
                  <IconComponent />
                </ListItemIcon>
                {open && (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    width="100%"
                  >
                    <ListItemText
                      primary={item.title}
                      primaryTypographyProps={{
                        fontFamily: isSelected
                          ? "Mulish-Bold"
                          : "Mulish-Regular",
                        color: isSelected ? "#fff" : colors.primary,
                      }}
                    />
                    {!item.noCount && (
                      <Box
                        sx={{
                          backgroundColor: isSelected
                            ? "rgba(255,255,255,0.05)"
                            : "rgba(25,34,52,0.05)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          marginLeft: "auto",
                          "&:hover": {
                            backgroundColor: colors.primary + "33",
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "Mulish-Bold",
                            color: isSelected ? "#FFF" : colors.primary,
                            fontSize: 12,
                            lineHeight: 1.5,
                          }}
                        >
                          {item?.count}
                        </Typography>
                      </Box>
                    )}
                  </Stack>
                )}
              </ListItemButton>
            </ListItem>
            {index !== sidebarData.length - 1 && <Divider sx={{ my: 0.5 }} />}
          </Tooltip>
        );
      })}
    </List>
  );
};

export default SidebarMenuItem;
